module.exports = __webpack_public_path__ + "img/world_map.28195f81.svg";